



























import { editFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store);
